import { Component, ViewChild, Output, EventEmitter } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { CompanyService } from '../../../services';
import { AppUtils } from '../../../helpers';

@Component({
    selector: 'app-company-challenge-delete',
    templateUrl: './company.challenge.delete.component.html'
})

export class CompanyChallengeDeleteComponent {
    @BlockUI('container-blockui-delete-popup') blockUI: NgBlockUI;
    @ViewChild('companyDeleteConfirmationModal', { static: true }) companyDeleteConfirmationModal: any;
    @Output() deleteCompany = new EventEmitter<any>();
    modalReference: NgbModalRef;
    deleteChallengeMessage: string;
    deleteConfirmationMessage: string;
    isModelLoaded = false;
    dualConfirmationRequired = true;

    constructor(private toastr: ToastrService,
        private modalService: NgbModal,
        private companyService: CompanyService,
        private appUtils: AppUtils) { }

    challengeDelete(id: number, companyName: string): void {
        this.blockUI.start();
        this.companyService.getCompanyStatisticsOfActiveRecords(id)
            .subscribe(
                (data: any) => {
                    this.blockUI.stop();
                    this.deleteConfirmationMessage = this.getDeleteConfirmationMessage(data, companyName);
                    this.isModelLoaded = true;
                },
                error => {
                    this.blockUI.stop();
                    this.appUtils.ProcessErrorResponse(this.toastr, error);
                });
    }

    getDeleteConfirmationMessage(data: any, companyName: string) {
        let htmlMessage = '';
        if (data.totalUsers === 0
            && data.totalFacilities === 0
            && data.totalUnits === 0
            && data.totalWorkOrders === 0) {
            this.dualConfirmationRequired = false;
            this.deleteChallengeMessage = 'DELETE';
            htmlMessage = 'Are you sure you want to delete the company account? This action is irreversible.';
        } else {
            let flag = false;
            htmlMessage = companyName + ' has ';
            if (data.totalUsers > 0) {
                htmlMessage += data.totalUsers + ' active ' + (data.totalUsers === 1 ? 'user ' : 'users ');
                flag = true;
            }
            if (data.totalFacilities > 0) {
                htmlMessage += (flag ? ', ' : '') +
                    (data.totalUsers > 0 && data.totalWorkOrders === 0 && data.totalUnits === 0 ? 'and ' : '')
                    + data.totalFacilities + ' active ' + (data.totalFacilities === 1 ? 'facility ' : 'facilities ');
                flag = true;
            }
            if (data.totalUnits > 0) {
                htmlMessage += (flag ? ', ' : '') +
                    ((data.totalUsers > 0 || data.totalWorkOrders > 0) && data.totalWorkOrders === 0 ? 'and ' : '')
                    + data.totalUnits + ' active ' + (data.totalUnits === 1 ? 'unit ' : ' units ');
                flag = true;
            }
            if (data.totalWorkOrders > 0) {
                htmlMessage += (flag ? ', ' : '') +
                    (data.totalUsers > 0 || data.totalWorkOrders > 0 || data.totalWorkOrders > 0 ? 'and ' : '')
                    + data.totalWorkOrders + ' active ' + (data.totalWorkOrders === 1 ? 'work order ' : 'work orders ');
            }

            if (htmlMessage.endsWith(',') || htmlMessage.endsWith(', ')) {
                htmlMessage = htmlMessage.trim().substr(0, htmlMessage.length - 1);
                console.log(htmlMessage);
            }

            htmlMessage += 'associated. Deleting ' + companyName + ' will delete all the data associated with it. \n'
                + 'Are you sure you want to proceed?';
        }

        return htmlMessage;
    }

    openCompanyDeleteConfirmationModal(id: number, companyName: string) {
        this.modalReference = this.modalService.open(this.companyDeleteConfirmationModal);
        this.challengeDelete(id, companyName);
    }

    delete() {
        this.closeCompanyDeleteConfirmationModal();
        setTimeout(() => {
            this.deleteCompany.emit();
        });
    }

    closeCompanyDeleteConfirmationModal() {
        this.modalReference.close();
        this.deleteChallengeMessage = null;
        this.deleteConfirmationMessage = null;
        this.dualConfirmationRequired = true;
        this.isModelLoaded = false;
    }

    deleteChallengeMessageChanged() {
        this.deleteChallengeMessage = this.deleteChallengeMessage.toUpperCase();
    }

}
